import { useRef } from 'react';
import {
  DrawerTooltipContainer,
  DrawerTooltipContainerRef,
} from 'src/v2/commonComponents/DrawerTooltipContainer';
import { MoreOptionsToggle } from 'src/v2/pages/subscription/components/MoreOptionsToggle';
import { CancelAutoPayForCreditsButton } from 'src/v2/pages/subscription/components/CancelAutoPayForCreditsButton';

const tooltipAnchorId = 'cancel-auto-pay-button-tooltip-anchor';

export const CancelAutoPay = () => {
  const drawerRef = useRef<DrawerTooltipContainerRef>(null);

  const handleClose = () => {
    drawerRef.current?.onVisibilityToggle();
  };

  return (
    <DrawerTooltipContainer
      ref={drawerRef}
      id={tooltipAnchorId}
      place="bottom-start"
      ToggleButton={MoreOptionsToggle}
      onlyTooltip
    >
      <CancelAutoPayForCreditsButton onClose={handleClose} />
    </DrawerTooltipContainer>
  );
};
